<template>
    <div class="ol-service">
        <div class="hotline">
            <span class="phone"
                  @click="showModal">
                <img src="../../images/icon_tel@2x.png">
                官方客服电话：010-50914766
            </span>

        </div>
        <v-modal :visible="visible"
                 @onCloseModal="handleCloseModal"></v-modal>

    </div>
</template>

<script>
import vModal from '@/components/modal';

export default {
    components: {
        vModal
    },
    data() {
        return {
            visible: false
        };
    },
    methods: {
        showModal() {
            this.visible = true;
        },
        handleCloseModal(val) {
            this.visible = val;
        }
    }
};
</script>

<style lang="scss" scoped>
.ol-service {
    background: #f76d32;
}
.hotline {
    margin: 0 auto;
    width: 1160px;
    height: 32px;
    line-height: 32px;
    color: #fff;
    font-size: 14px;
    .phone {
        cursor: pointer;
    }
    img {
        width: 16px;
        height: 16px;
        vertical-align: middle;
    }
}
</style>